import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import Logo from './Logo'
import Link from './Link'
import Search from './Icons/Search'
import SwitchLocale from './Locale/SwitchLocale'
import LogoNew from './LogoNew'

const Header = ({ isDisable, isMenuLight, onOpenCountrySelect, verticalScroll, onOpenSigin, onOpenSearch, isIndex, handleMenuOpen, openClaim, openSettings, isLogged, user, logOut, modalState, setModalState }) => {
  const header = classNames({
    'Header': true,
    'Header_disable': isDisable,
    '_light': isMenuLight,
  })

  return (
    <div>
      <div className={header}>
        <div className='Header__bg' />
        <div className='Header__body'>
          <button className='Burger' type='button' onClick={handleMenuOpen}>
            <span className='Burger__line' />
            <span className='Burger__line' />
            <span className='Burger__line' />
          </button>
          <div className='Header__menu'>
            {/*<Link to='/lots' className='Header__menu-link'>
              <FormattedMessage id='header.auctions' />
            </Link>
            <Link to='/fixedpricelots' className='Header__menu-link'>
              <FormattedMessage id='header.fixedprices' />
  </Link>
  <Link to='/help' className='Header__menu-link'>
              <FormattedMessage id='header.help' />
  </Link>
            <Link to='/funds' className='Header__menu-link'>
              <FormattedMessage id='header.foundations' />
            </Link>
            <Link to='/members' className='Header__menu-link'>
              <FormattedMessage id='header.participants' />
            </Link>*/}
            <Link to='/about' className='Header__menu-link'>
              О нас
            </Link>
            <Link to='/funds' className='Header__menu-link'>
              Фонды
            </Link>
            <Link to='/externalpartners' className='Header__menu-link'>
              Партнеры
            </Link>
            <Link to='/actions' className='Header__menu-link'>
              Акции
            </Link>
            {/*<Link to='/mechanics' className='Header__menu-link'>
              Механики
          </Link>*/}
          </div>
          <div className='Header__logo'>
            {isIndex
              ? <span className='Header__logo-img'><LogoNew /></span>
              : <Link to='/' className='Header__logo-img'><LogoNew /></Link>
            }
          </div>

          <div className='Header__rightside'>
            <Link to='/contacts' className='Header__loging-button'>
              Присоединиться
            </Link>
            {/*<SwitchLocale onClick={onOpenCountrySelect} />
            {isLogged
              ? (
                <div className='Header__dropdown'>
                  <Link to='/profile' className='Header__loging-button'>{user.name}</Link>
                  <div className='Header__dropdown-list'>
                    <Link to='/profile' className='Header__dropdown-item'>
                      <FormattedMessage id='header.profile' />
                    </Link>
                    <button className='Header__dropdown-item' onClick={openClaim} >
                      <FormattedMessage id='header.become_participant' />
                    </button>
                    <button className='Header__dropdown-item' onClick={openSettings}>
                      <FormattedMessage id='header.settings' />
                    </button>
                    <button className='Header__dropdown-item' onClick={logOut}>
                      <FormattedMessage id='header.logout' />
                    </button>
                  </div>
                </div>
              )
              : (
                <button className='Header__loging-button' onClick={onOpenSigin}>
                  <FormattedMessage id='header.login' />
                </button>
              )
            }*/}
            <button className='Header__search-button' onClick={onOpenSearch}>
              <span className='Header__search-img'><Search /></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.jsx